import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import Select from "react-select"
import AxiosConfig from "../../../../../../../../../utilities/AxiosConfig"
import snackBar from "../../../../../../../../../utilities/snackBar/SnackBar"
import EditIncidentTypes from "../../../../../../../Types/EditIncidentTypes"
import ReferenceTypes from "../../../../../../../Types/ReferenceTypes"
import SupervisorTypes from "../../../../../../../Types/SupervisorTypes"
import "./AddSupervisor.css"

interface Props {
    toggleAddSupervisor: Function
    appendParams: Function
    reference: ReferenceTypes
    incident: EditIncidentTypes
    userId: string | number
    updateSupervisors: Function

}

interface State {
    stagedSupervisors: Array<SupervisorTypes>
    saving: boolean
    isDirty: boolean
    confirmDiscard: boolean
}

class AddSupervisor extends Component<Props, State> {

    supervisorDex = 0
    tempSupervisorList: Array<SupervisorTypes> = []
    timeFormat = "YYYY-MM-DD"

    state = {
        stagedSupervisors: [],
        saving: false,
        isDirty: false,
        confirmDiscard: false
    }

    handleAddSupervisor = (supervisors: Array<any>) => {
        if (supervisors) {
            let incident = this.props.incident
            let temp = []
            for (let i = 0; i < supervisors.length; i++) {
                let supervisor = JSON.parse(supervisors[i].value)
                let newSupervisor: SupervisorTypes = {
                    IncidentSupervisorId: null,
                    IncidentId: incident.WorkersCompensationIncidentId,
                    SupervisorId: supervisor.id,
                    SupervisorDisplayName: supervisor.text,
                    SupervisorPhone: supervisor.phone || "*NA*",
                    SupervisorEmail: supervisor.email || "NA",
                    CreatedDateUTC: moment(Date.now()).format(this.timeFormat),
                    CreatedBy: this.props.userId,
                    DeletedDateUTC: null,
                    DisabledDateUTC: null,
                }
                temp.push(newSupervisor)
            }
            this.setState({ stagedSupervisors: temp, isDirty: true })
        } else {
            this.setState({ stagedSupervisors: [], isDirty: false })
        }
    }

    save = () => {
        this.setState({ saving: true })
        for (let i = 0; i < this.state.stagedSupervisors.length; i++) {
            axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentSupervisorPost", this.state.stagedSupervisors[i], AxiosConfig.configValue("min"))
                .then((res) => {
                    if (i === this.state.stagedSupervisors.length - 1) {
                        snackBar({ text: "Supervisors updated", type: "success", timeout: 4000 })
                        this.setState({ saving: false })
                        this.props.updateSupervisors(this.state.stagedSupervisors)
                    }
                })
                .catch(err => {
                    this.supervisorDex = 0
                    this.setState({ stagedSupervisors: [], saving: false })
                    //console.log(err)
                    snackBar({ text: "Error saving supervisors", type: "error", timeout: 4000 })
                    this.setState({ saving: false })
                })
        }
    }

    back = () => {
        if (!this.state.isDirty) {
            this.props.toggleAddSupervisor()
        } else {
            this.setState({ confirmDiscard: true })
        }
    }

    shouldDiscard = (discard: boolean) => {
        if (discard) {
            this.props.toggleAddSupervisor()
        } else {
            this.setState({ confirmDiscard: false })
        }
    }

    render() {

        // //console.log("Add Supervisor state: ", this.state)
        // //console.log("Add Supervisor props: ", this.props)

        return (
            <div className="AddSupervisor">
                {!this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="AddSupervisorHeader">
                            <p>Add Supervisors</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="AddSupervisorBody">
                            {this.props.reference.supervisors && <Select
                                placeholder="Add Supervisors"
                                isMulti={true}
                                options={this.props.reference.supervisors.map(s => ({ value: JSON.stringify(s), label: s.text }))}
                                onChange={(supervisors: any) => {
                                    // this.props.appendParams([{ Supervisor: item.label }, { SupervisorId: item.value }])
                                    this.handleAddSupervisor(supervisors)
                                }}
                                menuPlacement="bottom"
                                maxMenuHeight={400}
                            />}
                            {this.state.stagedSupervisors.length > 0 && <div className="AddSupervisorSupervisorList">
                                <p id="add-supervisor-supervisor-list-header">New Supervisors:</p>
                                {this.state.stagedSupervisors.map((supervisor: SupervisorTypes, index: number) =>
                                    <div className="AddSupervisorSupervisorListItem" key={supervisor.SupervisorId}>
                                        <p>{`${index + 1}) ${supervisor.SupervisorDisplayName}`}</p>
                                    </div>
                                )}
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddSupervisorFooter">
                            {!this.state.saving && <Button id="add-supervisor-back-btn" variant="secondary" onClick={() => this.back()}>Cancel</Button>}
                            {this.state.stagedSupervisors.length > 0 && !this.state.saving && <Button id="add-supervisor-save-btn" variant="primary" onClick={() => this.save()}>Save</Button>}
                            {this.state.saving && <Spinner id="add-supervisor-saving-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="IncidentDiscardModalHeader">
                            <p>Are you sure you want to quit? Any unsaved changes will be lost.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="IncidentDiscardModalFooter">
                            <Button id="add-appointment-discard-btn-dicard" variant="danger" onClick={() => this.shouldDiscard(true)}>Quit</Button>
                            <Button id="add-appointment-discard-back-btn" variant="secondary" onClick={() => this.shouldDiscard(false)} >Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }

}

export default AddSupervisor